import React, { useEffect } from 'react';
import App from './App';
import { ContextProvider } from './teal-react/hooks/useAppState';
import GraphqlProvider from './graphql/GraphqlProvider';
import { getTokenData, onTokenChange, useAuth } from './teal-react/utils/token';
import { schema } from './graphql/schema';

interface IConfig {
  graphql_path: string;
  schema: any;
  token?: string;
  update_by_field?: string;
  update_by?: string;
}

const AppContext = () => {
  const { token, user } = useAuth();
  let init_config: IConfig = {
    graphql_path:
      (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '') +
      '/graphql',
    schema,
    token,
    update_by_field: 'updated_by',
    update_by: user?.email,
  };
  const [config, set_config] = React.useState(init_config);

  useEffect(() => {
    onTokenChange((token: string) => {
      const u = getTokenData();
      // console.log('ontokenchange', { u });
      set_config({
        ...config,
        token,
        schema,
        update_by_field: 'updated_by',
        update_by: u?.e,
      });
    });

    // eslint-disable-next-line
  }, []);

  return (
    <GraphqlProvider config={config}>
      <ContextProvider>
        <App />
      </ContextProvider>
    </GraphqlProvider>
  );
};

export default AppContext;
